import React from 'react';
import {classes} from './ItemDetails.st.css';
import {Text} from '@wix/wix-ui-tpa/cssVars';

export const DetailLine = ({value, dataHook}: {value: string; dataHook?: string}) => {
  return (
    <Text data-hook={dataHook} className={classes.option}>
      {value}
    </Text>
  );
};
